export default __webpack_public_path__ + "static/media/ru.e654d588.svg";